const state = () => ({
  info: {},
  date: {},
  dropoffTime: '00:00',
  pickupTime: '00:00',
})

// const mutations =
export default {
  namespaced: true,
  state: {
    info: {},
    date: {},
    dropoffTime: '00:00',
    pickupTime: '00:00',
  },
  mutations: {
    add (state, formValues) {
      state.info = { ...state.info, ...formValues }
    },
    addDate (state, formValues) {
      state.date = formValues
    },
    addVehicleInfo (state, formValues) {
      state.info = { ...state.info, ...formValues }
    },
    addIssuer (state, issuer) {
      state.info = { ...state.info, issuer }
    },
    addDropoffTime (state, dropoffTime) {
      state.dropoffTime = dropoffTime
    },
    addPickupTime (state, pickupTime) {
      state.pickupTime = pickupTime
    },
    remove (state) {
      state.info = {}
    },
    reset (state) {
      state.info = {}
      state.date = {}
      state.dropoffTime = '00:00'
      state.pickupTime = '00:00'
    },
  },
  actions: {},
  getters: {
    state: state => state,
  },
}
